<mat-dialog-content
  [ngStyle]="{ 'padding-left': '16px', 'padding-right': '16px' }"
>
  <ng-container *ngIf="showUnsavedChangesPrompt">
    <mat-dialog-content>
      <p
        i18n="@@profileView.messageDialog.unsavedChanges.prompt"
        class="u-marginBottom-16"
      >
        Are you sure you want to discard your message?
      </p>
    </mat-dialog-content>
  </ng-container>
  <ng-container *ngIf="!showUnsavedChangesPrompt">
    <mat-form-field class="mat-form-field-width-100">
      <mat-label i18n="@@profileView.messageDialog.textAreaLabel"
        >Send a message</mat-label
      >
      <textarea
        [formControl]="messagingForm"
        matInput
        cdkTextareaAutosize
        [cdkAutosizeMinRows]="6"
        [cdkAutosizeMaxRows]="12"
      >
      </textarea>
    </mat-form-field>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <div fxLayout="row" fxLayoutAlign="end center" class="u-width-100">
    <div class="u-marginRight-8">
      <button
        i18n="@@global.cancel"
        mat-button
        (click)="
          showUnsavedChangesPrompt
            ? showMessageDialog()
            : checkForUnsavedChanges()
        "
      >
        Cancel
      </button>
    </div>
    <ng-container *ngIf="showUnsavedChangesPrompt">
      <button
        i18n="@@global.okay"
        mat-raised-button
        color="primary"
        mat-dialog-close
      >
        Okay
      </button>
    </ng-container>
    <ng-container *ngIf="!showUnsavedChangesPrompt">
      <button
        i18n="@@profileView.messageDialog.send.buttonLabel"
        mat-raised-button
        color="primary"
        (click)="sendMessage(messagingForm)"
        [disabled]="messagingForm.invalid || isLoading"
        appTrackClick
        [elementCustomId]="'profile-sendMessage-' + data.analyticNameSuffix"
      >
        Send Message
      </button>
    </ng-container>
  </div>
</mat-dialog-actions>
